
import React from "react";
import { LIFE_STYLE_PERSONAL_DETAILS } from './LifeStylePersonalDetails_questions';
import { HEALTH_RECORDS } from './health_records_questions'
import { Tab } from "react-bootstrap";
import QuestionRenderer from './QuestionRenderer';
import TabContainer from "../../../components/Tabs";
class HealthQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    return (
      <TabContainer defaultActiveKey="ownerQuestions">
        {this.props.proposalData.customerDetails.proposerDetails.questions &&
          <Tab eventKey="ownerQuestions" title="Owner Questions">

            <QuestionRenderer
              questions={this.props.proposalData.customerDetails.proposerDetails.questions}
              // questionData={LIFE_STYLE_PERSONAL_DETAILS()}
            />
          </Tab>
        }
        {
          this.props.proposalData.customerDetails.insuredDetails.questions &&
          <Tab eventKey="insuredQuestions" title="Insured Questions">
            <QuestionRenderer
              // questionData={LIFE_STYLE_PERSONAL_DETAILS()}
              questions={this.props.proposalData.customerDetails.insuredDetails.questions}
            />
            
          </Tab>
        }

      </TabContainer>
    )

  }
};

export default HealthQuestions
